module.exports = __webpack_public_path__ + "static/mary-kay-2-a7c42ab173b53a63e44838fb83a3228d.jpg";